<template>
  <div class="ContainerHomePostagensMain">
    <Navbar />
    <div id="ContainerHomePostagens">
      <section class="container flex-end" v-if="this.tamanhoVetor > 2">
        <router-link to="/postagens/escreva">
          <b-button id="buttonEscrevaAqui" class="buttonEscreva">
            Escreva aqui
          </b-button>
        </router-link>
      </section>
      <b-row
        id="cardsLinhas"
        align-h="center"
        align-v="center"
        class="linha"
        v-for="(item, index) in items"
        :key="index"
      >
        <template>
          <b-col cols="8">
            <b-card no-body class="card">
              <b-card-body>
                <router-link :to="`/postagens/postagem/${item._id}`">
                  <b-card-title class="title">{{ item.title }} </b-card-title>

                  <b-card-text class="message">
                    {{ item.message }}
                  </b-card-text>
                </router-link>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col cols="2" md="2" lg="1">
            <router-link :to="`/postagens/postagem/${item._id}`"
              ><b-icon-chevron-right class="h1 icon" scale=""></b-icon-chevron-right>
            </router-link>
          </b-col>
        </template>
      </b-row>
      <b-row class="linha" align-h="center">
        <b-col cols="auto" md="auto" lg="auto">
          <b-button
            v-if="this.anonymousContactsCount > 3"
            id="buttonVerMais"
            class="buttonVer"
            @click="aumentaVetor"
          >
            Ver Mais
          </b-button>
          <b-button id="buttoninicio" class="buttoninicioa" @click="scrollToTop">
            Ir para o início
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/home/navbar.vue';
import { GetAnonymousAproved } from '@/services/api/AnonymousContact.js';
export default {
  components: {
    Navbar,
  },
  data() {
    return {
      items: [],
      anonymous: [],
      tamanhoVetor: 0,
      quantidadeVetor: 3,
      currentPage: 1,
      perPage: 3,
      totalPages: null,
      anonymousContactsCount: 0,
    };
  },
  created() {
    window.addEventListener('scroll', this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  },
  methods: {
    scroll() {
      const scrolled = window.pageYOffset;
      var elmnt = document.getElementById('ContainerHomePostagens');
      var soma = elmnt.clientHeight - 450;
      if (this.tamanhoVetor > 2) {
        if (elmnt.clientHeight == 0) {
          document
            .getElementById('buttonEscrevaAqui')
            .classList.replace('mudar', 'buttonEscreva');
        } else {
          if (scrolled >= soma) {
            document
              .getElementById('buttonEscrevaAqui')
              .classList.replace('buttonEscreva', 'mudar');
            document.getElementById('buttonEscrevaAqui').style.top =
              elmnt.clientHeight + 30 + 'px';
          } else {
            document
              .getElementById('buttonEscrevaAqui')
              .classList.replace('mudar', 'buttonEscreva');
            document.getElementById('buttonEscrevaAqui').removeAttribute('style');
          }
        }
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    aumentaVetor() {
      GetAnonymousAproved(this.perPage, this.currentPage)
        .then((res) => {
          this.currentPage += 1;
          this.totalPages = res.data.totalPages;
          this.items = this.items.concat(res.data.anonymousContacts);
          if (this.currentPage > this.totalPages) {
            document.getElementById('buttonVerMais').style.display = 'none';
            document.getElementById('buttoninicio').style.display = 'block';
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  mounted() {
    GetAnonymousAproved(this.perPage, this.currentPage)
      .then((res) => {
        this.totalPages = res.data.totalPages;
        this.items = res.data.anonymousContacts;
        this.tamanhoVetor = Object.keys(this.items).length;
        this.anonymousContactsCount = res.data.anonymousContactsCount;
        if (this.tamanhoVetor >= 1) {
          document
            .getElementById('ContainerHomePostagens')
            .classList.remove('ContainerHomePostagens');
          // if (this.tamanhoVetor == 2) {
          //   document
          //     .getElementById('buttonEscrevaAqui')
          //     .classList.replace('buttonEscreva', 'warning');
          // }
        }
        this.currentPage += 1;
      })
      .catch((error) => {
        if (error.response.data.erro == 'Instâncias não foram encontradas') {
          document
            .getElementById('ContainerHomePostagens')
            .classList.add('ContainerHomePostagens');
        } else {
          this.$bvToast.toast(
            'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
            {
              title: 'Erro interno no servidor',
              autoHideDelay: 100000, //Tempo em milissegundos para o toast desaparecer
              variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
            },
          );
        }
      });
  },
};
</script>

<style lang="scss" scoped>
$fontBody: 'Montserrat', sans-serif;
* {
  background-color: #fffaf4;
}
a {
  text-decoration: none;
}
.mr-2 {
  background-color: #f8d7dad9;
}
.btn {
  border-color: #a33965;
}
.btn:hover {
  font-weight: bold;
}

.flex-end {
  // justify-content: flex-end;
  display: inline;
  float: right;
}
.navbar {
  margin-bottom: 3rem;
}
#cardsLinhas {
  padding-top: 2.5rem;
}
.linha.row {
  margin: 0;
}
.buttonVerMais {
  background-color: #a33965;
}
.buttoninicioa {
  background-color: #a33965;
}

#buttoninicio {
  display: none;
}
.icon {
  color: #363636;
}
@media (max-width: 320px) {
  .icon {
    height: 2rem;
  }
}
@media (max-width: 280px) {
  .icon {
    height: 2rem;
  }
}
</style>
<style lang="scss">
$fontTitle: 'Yeseva One', cursive;
$fontBody: 'Montserrat', sans-serif;
.ContainerHomePostagensMain {
  margin-top: 3rem;
  max-width: 100vw;
  .ContainerHomePostagens {
    height: 30rem;
  }
  .title {
    font-family: $fontTitle;
    font-style: normal;
    font-weight: 400;
    font-size: 3rem;
    color: #363636;
  }
  .message {
    font-family: $fontBody;
    font-style: normal;
    font-weight: 600;
    overflow: hidden; // Removendo barra de rolagem
    text-overflow: ellipsis; // Adicionando "..." ao final
    display: -webkit-box;
    -webkit-line-clamp: 4; // Quantidade de linhas
    -webkit-box-orient: vertical;
    color: #363636;
    font-size: 1.5;
    max-width: 39rem;
  }
  #buttonVerMais.buttonVer.btn-secondary {
    background-color: #a33965 !important;
    margin-top: 2rem;
    margin-bottom: 4rem;
    font-family: $fontBody;
    font-size: 1.6rem;
    border-radius: 8px;
    width: 12rem;
  }
  #buttonEscrevaAqui.buttonEscreva.btn-secondary {
    background-color: #a33965 !important;
    margin-left: 1rem;
    margin-top: 1rem;
    font-family: $fontBody;
    font-size: 1.7rem;
    width: 14rem;
    height: 4rem;
    border-radius: 8px;
    z-index: 20;
    position: fixed;
    right: 1.5em;
  }
  #buttonEscrevaAqui.warning1.btn-secondary {
    background-color: #a33965 !important;
    margin-top: 2rem;
    font-family: $fontBody;
    font-weight: bolder;
    font-size: 1.7rem;
    width: 14rem;
    height: 4rem;
    border-radius: 8px;
    z-index: 20;
    position: fixed;
    right: 1.5em;
    top: 14rem;
  }
  #buttonEscrevaAqui.warning.btn-secondary {
    background-color: #a33965 !important;
    margin-top: 2rem;
    font-family: $fontBody;
    font-weight: bolder;
    font-size: 1.7rem;
    width: 14rem;
    height: 4rem;
    border-radius: 8px;
    z-index: 20;
    position: fixed;
    right: 1.5em;
    top: 21rem;
  }
  #buttonEscrevaAqui.mudar.btn-secondary {
    background-color: #a33965 !important;
    margin-left: 1rem;
    margin-top: 1rem;
    font-family: $fontBody;
    font-size: 1.7rem;
    width: 14rem;
    height: 4rem;
    border-radius: 8px;
    z-index: 20;
    position: absolute;
    right: 1.5rem;
  }
  .card {
    background-color: transparent !important;
    border: none;
  }
  #buttoninicio.buttoninicioa.btn-secondary {
    background-color: #a33965 !important;
    margin-top: 2rem;
    margin-bottom: 4rem;
    font-family: 'Montserrat', sans-serif;
    width: 10rem;
    font-size: 1.4rem;
    border-radius: 8px;
  }
  @media (min-height: 0px) and (max-height: 768px) {
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      bottom: 2rem;
    }
  }
  @media (min-height: 770px) and (max-height: 1364px) {
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      top: 36rem;
    }
  }
  @media (min-height: 1366px) {
    .ContainerHomePostagens {
      height: 60rem;
    }
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      top: 36rem;
    }
  }
  @media (min-width: 426px) and (max-width: 768px) {
    .ContainerHomePostagens {
      height: 30rem;
    }
    .title {
      font-size: 2.1rem;
    }
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      width: 8rem;
      height: 5rem;
      margin-left: 2rem;
      font-size: 1.37rem;
    }
    #buttonEscrevaAqui.warning.btn-secondary {
      width: 8rem;
      height: 5rem;
      font-size: 1.37rem;
    }
    #buttonEscrevaAqui.warning1.btn-secondary {
      width: 8rem;
      height: 5rem;
      font-size: 1.37rem;
    }
    #buttonEscrevaAqui.mudar.btn-secondary {
      width: 8rem;
      height: 5rem;
      margin-left: 2rem;
      font-size: 1.37rem;
    }
  }
  @media (min-width: 376px) and (max-width: 425px) {
    .ContainerHomePostagens {
      height: 25rem;
    }
    .title {
      font-size: 2rem;
    }
    #buttonVerMais.buttonVer.btn-secondary {
      font-weight: 600;
      font-size: 1.37rem;
      width: 9rem;
    }
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      width: 8rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.37rem;
    }
    #buttonEscrevaAqui.warning.btn-secondary {
      width: 8rem;
      height: 5rem;
      font-size: 1.37rem;
    }
    #buttonEscrevaAqui.warning1.btn-secondary {
      width: 8rem;
      height: 5rem;
      font-size: 1.37rem;
    }
    #buttonEscrevaAqui.mudar.btn-secondary {
      width: 8rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.37rem;
    }
    #buttoninicio.buttoninicioa.btn-secondary {
      font-weight: 600;
      font-size: 1.2rem;
      width: 8rem;
    }
  }
  @media (min-width: 321px) and (max-width: 375px) {
    .ContainerHomePostagens {
      height: 25rem;
    }
    .title {
      font-size: 1.9rem;
    }
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      width: 7rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.3rem;
    }
    #buttonEscrevaAqui.warning.btn-secondary {
      width: 7rem;
      height: 5rem;
      font-size: 1.3rem;
    }
    #buttonEscrevaAqui.warning1.btn-secondary {
      width: 7rem;
      height: 5rem;
      font-size: 1.3rem;
    }
    #buttonEscrevaAqui.mudar.btn-secondary {
      width: 7rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.3rem;
    }
    .message {
      overflow: hidden; // Removendo barra de rolagem
      text-overflow: ellipsis; // Adicionando "..." ao final
      display: -webkit-box;
      -webkit-line-clamp: 5; // Quantidade de linhas
      -webkit-box-orient: vertical;
      width: 11rem;
    }
    #buttonVerMais.buttonVer.btn-secondary {
      font-weight: 600;
      font-size: 1.37rem;
      width: 9rem;
    }
    #buttoninicio.buttoninicioa.btn-secondary {
      font-weight: 600;
      font-size: 1.2rem;
      width: 8rem;
    }
  }
  @media (max-width: 320px) {
    .ContainerHomePostagens {
      height: 25rem;
    }
    .title {
      font-size: 1.7rem;
    }
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      width: 6rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.2rem;
    }
    #buttonEscrevaAqui.warning.btn-secondary {
      width: 6rem;
      height: 5rem;
      font-size: 1.2rem;
    }
    #buttonEscrevaAqui.warning1.btn-secondary {
      width: 6rem;
      height: 5rem;
      font-size: 1.2rem;
    }
    #buttonEscrevaAqui.mudar.btn-secondary {
      width: 6rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.2rem;
    }
    .message {
      overflow: hidden; // Removendo barra de rolagem
      text-overflow: ellipsis; // Adicionando "..." ao final
      display: -webkit-box;
      -webkit-line-clamp: 5; // Quantidade de linhas
      -webkit-box-orient: vertical;
      width: 11rem;
    }
    #buttonVerMais.buttonVer.btn-secondary {
      font-weight: 600;
      font-size: 1.37rem;
      width: 9rem;
    }
    #buttoninicio.buttoninicioa.btn-secondary {
      font-weight: 600;
      font-size: 1.2rem;
      width: 8rem;
    }
  }
  @media (max-width: 280px) {
    .ContainerHomePostagens {
      height: 25rem;
    }
    .title {
      font-size: 1.4rem;
    }
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      width: 5.6rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.1rem;
    }
    #buttonEscrevaAqui.warning.btn-secondary {
      width: 5.6rem;
      height: 5rem;
      font-size: 1.1rem;
    }
    #buttonEscrevaAqui.warning1.btn-secondary {
      width: 5.6rem;
      height: 5rem;
      font-size: 1.1rem;
    }
    #buttonEscrevaAqui.mudar.btn-secondary {
      width: 5.6rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.1rem;
    }
    .message {
      overflow: hidden; // Removendo barra de rolagem
      text-overflow: ellipsis; // Adicionando "..." ao final
      display: -webkit-box;
      -webkit-line-clamp: 5; // Quantidade de linhas
      -webkit-box-orient: vertical;
      width: 10rem;
    }
  }
}
</style>
